require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-glennsl-bs-json.json") })
        }
      }, "path---package-glennsl-bs-json");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-glennsl-bs-json!./.cache/json/package-glennsl-bs-json.json
// module id = 864
// module chunks = 231608221292675